<template>
    <v-container>
    <v-row class="text-center">
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          :search="search"
          :options="{itemsPerPage: 100}"
          :footer-props="{ 'items-per-page-options': [50, 100, 200, 500, -1]}"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>FLEX Leaderboard</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer/>
              Pokazuj tylko graczy z Kuźni <v-switch v-model="onlyKuznia">abc</v-switch>
            </v-toolbar>
          </template>
          <template v-slot:[`item.index`]="{_, index}">
            {{ index + 1 }}
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <a :href="getLeagueGraphsLink(item.player_name)">{{ item.player_name }}</a>
          </template>
          <template v-slot:[`item.points`]="{ item }">
            {{ item.tier }} {{ item.points }} LP
          </template>
          <template v-slot:[`item.wins`]="{ item }">
            {{ item.wins }} / {{ item.losses }} ({{ (item.wins / (item.wins + item.losses) * 100).toFixed(2) }}%)
          </template>
          <template v-slot:footer>
            Last updated {{ moment(lastUpdated).fromNow(true) }} ago.
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>
.v-toolbar .v-input {
  padding-top: 20px;
  padding-left: 20px;
}
.v-application a {
  color: inherit;
  text-decoration: none;
}
</style>

<script setup>
import {computed, onMounted, ref} from "vue";
import axios from "axios";
import moment from "moment";

const search = ref('');
const onlyKuznia = ref(false);
const items = ref([
    {rank: 1, name: 'Kowalo', points: 1005, wins: 77, losses: 23, is_kuznia: true},
    {rank: 2, name: 'Satanael', points: 12, wins: 66, losses: 66, is_kuznia: false},
]);
const lastUpdated = ref('');

const filteredItems = computed(() => {
  return items.value.filter(i => !onlyKuznia.value || i.is_kuznia);
})
const headers = computed(() => {
  return [
    {
      text: '#',
      sortable: true,
      value: 'index',
    },
    {
      text: 'Nazwa',
      value: 'name',
    },
    {
      text: 'Punkty',
      value: 'points',
    },
    {
      text: 'W / L',
      value: 'wins',
    },
  ]
})

const getLeagueGraphsLink = (name) => {
  const stripedName = name.replace('#', '-')
  return `https://www.leagueofgraphs.com/summoner/eune/${stripedName}`;
}

onMounted(async () => {
  await axios.get('/api/ladder/').then(response => {
    lastUpdated.value = response.data.date;
    items.value = response.data.positions;
  });
});

</script>